import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../modules';
import {
  setSearchKeyword,
  searchKeywordState,
} from '../../modules/searchKeyword';
import {
  setIsMoreInfoAttachment,
  setIsMoreInfoResult,
  tabResultState,
  setSearchDataNull,
} from '../../modules/tabResult';

import Main from '../../components/main';
import {
  setIsMoreInfoPath0,
  setIsMoreInfoPath1,
  setIsMoreInfoPath2,
  tabAIState,
  setAIDataNull,
} from '../../modules/tabAI';

import {
  setSettingId,
  mainState,
  getTotalRecommendAsync,
  getWordCloudAsync,
  getPopularContentsAsync,
} from '../../modules/main';
import { GetTotalRecommendParamType } from '../../lib/main/type';
import { setImageDataNull } from '../../modules/tabImage';
import { PostConsumptionBodyType } from '../../lib/common/type';
import { postConsumptionAsync } from '../../modules/common';

function MainContainer() {
  const {
    settingId,
    totalRecommendData,
    popularContentsData,
    wordCloudData,
  } = useSelector((state: RootState) => state.main);
  const dispatch = useDispatch();

  const onPostConsumption = (info: PostConsumptionBodyType) => {
    dispatch(postConsumptionAsync.request(info));
  };

  const onSetIsMoreInfoResult = (
    isMoreInfoResult: tabResultState['isMoreInfoResult']
  ) => {
    dispatch(setIsMoreInfoResult(isMoreInfoResult));
  };

  const onSetIsMoreInfoAttachment = (
    isMoreInfoAttach: tabResultState['isMoreInfoAttach']
  ) => {
    dispatch(setIsMoreInfoAttachment(isMoreInfoAttach));
  };

  const onSetSearchKeyword = (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => {
    dispatch(setSearchKeyword(searchKeyword));
  };
  // ai추천 탭 상세보기
  const onSetIsMoreInfoPath0 = (
    isMoreInfoPath0: tabAIState['isMoreInfoPath0']
  ) => {
    dispatch(setIsMoreInfoPath0(isMoreInfoPath0));
  };
  const onSetIsMoreInfoPath1 = (
    isMoreInfoPath1: tabAIState['isMoreInfoPath1']
  ) => {
    dispatch(setIsMoreInfoPath1(isMoreInfoPath1));
  };
  const onSetIsMoreInfoPath2 = (
    isMoreInfoPath2: tabAIState['isMoreInfoPath2']
  ) => {
    dispatch(setIsMoreInfoPath2(isMoreInfoPath2));
  };
  // 설정하기
  const onSetSettingId = (settingId: mainState['settingId']) => {
    dispatch(setSettingId(settingId));
  };
  const onGetTotalRecommend = (info: GetTotalRecommendParamType) => {
    dispatch(getTotalRecommendAsync.request(info));
  };
  const onGetPopularContents = () => {
    dispatch(getPopularContentsAsync.request(null));
  };
  const onGetWordCloud = () => {
    dispatch(getWordCloudAsync.request(null));
  };
  // 탭 이동 및 데이터 null 셋팅

  const onSetSearchDataNull = () => {
    dispatch(setSearchDataNull());
  };
  const onSetAIDataNull = () => {
    dispatch(setAIDataNull());
  };
  const onSetImageDataNull = () => {
    dispatch(setImageDataNull());
  };

  useEffect(() => {
    onGetTotalRecommend({
      session: localStorage.getItem('aivory_session_id') || 'test_session',
      total_count: 20,
    });
    onGetPopularContents();
    onGetWordCloud();
    onSetSearchKeyword('');

    onSetIsMoreInfoResult(false);
    onSetIsMoreInfoAttachment(false);
    onSetIsMoreInfoPath0(false);
    onSetIsMoreInfoPath1(false);
    onSetIsMoreInfoPath2(false);
    onSetSearchDataNull();
    onSetAIDataNull();
    onSetImageDataNull();
  }, []);

  return (
    <Main
      onSetSettingId={onSetSettingId}
      onGetTotalRecommend={onGetTotalRecommend}
      onPostConsumption={onPostConsumption}
      settingId={settingId}
      totalRecommendData={totalRecommendData}
      popularContentsData={popularContentsData}
      wordCloudData={wordCloudData}
    />
  );
}

export default MainContainer;
